import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTimePickerInputComponent } from './fi-time-picker-input.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiInputMaskModule } from '@fi-shared/fi-directives/fi-input-mask/fi-input-mask.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiTimePickerHelperService } from '@fi-shared/fi-time-picker-input/fi-time-picker-helper.service';
import { FiTimePickerSegmentInputComponent } from './fi-time-picker-segment-input/fi-time-picker-segment-input.component';

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        ReactiveFormsModule,
        FiInputMaskModule,
        FormsModule,
        MatIconModule,
        MatButtonModule,
        FiAppTextSharedModule,
    ],
    declarations: [FiTimePickerInputComponent, FiTimePickerSegmentInputComponent],
    providers: [FiTimePickerHelperService],
    exports: [FiTimePickerInputComponent],
})
export class FiTimePickerInputModule {}
